import React from "react";
import { TAttribute } from '../model';

type AttributeListItemProps = {
  item: TAttribute;
  isSelected: boolean;
  onToggle: (id: string) => void;
};


const AttributeListItemRB = ({ item, isSelected, onToggle }: AttributeListItemProps) => {
  return (
    <div onClick={() => onToggle(item.id)} className="tw-flex tw-cursor-pointer tw-items-center tw-mb-2 tw-">
      <input
        type="radio"
        checked={isSelected}
        onChange={() => {}}
        className="tw-mr-2"
        name="attributeRadio" // Add a unique name for the radio group
      />
      <span className="tw-text-[#172B4D] tw-text-sm">{item?.name ?? ''}</span>
    </div>
  );
};

export default AttributeListItemRB;
